import { Sheet } from 'react-modal-sheet';
import styled from 'styled-components';
import ModalTopBg from '/img/modal/modal-top.png';
import { CommonButton } from '../common/CommonButton';

export const ThirdAgreePrivacy = ({
  thirdAgree,
  close,
}: {
  thirdAgree: boolean;
  close: () => void;
}) => (
  <Sheet
    isOpen={thirdAgree}
    onClose={close}
    tweenConfig={{ ease: 'easeOut', duration: 0.2 }}
    detent={'content-height'}
  >
    <Backdrop onTap={() => {}} />
    <Sheet.Container style={{ backgroundColor: 'transparent' }}>
      <Container>
        <TitleContainer>
          <Title style={{ textAlign: 'left' }}>개인정보 3자 제공 동의</Title>
        </TitleContainer>
        <Content style={{ paddingTop: 10 }}>
          <AgreeSwitchArea style={{ marginBottom: 24 }}>
            <ContentItemList>
              <ContentItem>
                네오위즈는 오프라인 홀덤 토너먼트 참가권 지급을 위해 아래와 같이 개인정보를
                공유합니다.
              </ContentItem>
              <ContentItem>
                1. 개인정보를 공유받는 자 : CTP(CTP가 토너먼트 진행을 위하여 개인정보 취급위탁할 수
                있음)
                <br />
                2. 개인정보의 공유 목적 : 홀덤 토너먼트 참가권 지급
                <br />
                3. 공유하는 개인정보 항목 : 이름, 생년월일
                <br />
                4. 개인정보의 공유기간 : 동의일로부터 3개월
              </ContentItem>
              <ContentItem>
                귀하께서는 개인정보의 제공(공유)에 대한 동의를 거부할 수 있는 권리가 있습니다.
                <br /> 다만 동의에 거부할 경우 오프라인 홀덤 토너먼트 참가권 지급이 불가할 수
                있습니다.
              </ContentItem>
            </ContentItemList>
          </AgreeSwitchArea>

          <CommonButton text="닫기" click={close} />
        </Content>
      </Container>
    </Sheet.Container>
  </Sheet>
);

const ContentItemList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;

const ContentItem = styled.li`
  color: #b2b2b2;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.7px;
  margin-bottom: 7px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Backdrop = styled(Sheet.Backdrop)`
  background-color: rgb(0, 0, 0, 0.5) !important;
`;

const TitleContainer = styled.div`
  height: 64px;
  padding-top: 35px;
  background-image: url(${ModalTopBg});
  background-size: cover;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding-left: 20px;
  padding-right: 20px;
`;

const Title = styled.h3`
  color: #fbf6d5;
  text-align: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 17px;
  letter-spacing: -0.17px;
`;

const Container = styled.div``;

const Content = styled.div`
  background: #302e2d;
  padding: 0px 10px 30px 10px;
`;

const AgreeSwitchArea = styled.div`
  padding: 21px 20px 18px 20px;
  border-radius: 9px;
  background: #201f1e;
`;
